import { useEffect } from 'react';
import { suppressLiveChat } from '../components/liveChatConfig';
import { suppressFloatingWidgets } from '../lib/floatingWidgets';

/** Sayfa açıkken canlı destek / sohbet düğmelerini gizler.
 *
 * Sohbet düğmesi ekranın sağ alt köşesinde durur ve bazı sayfalarda oyuncunun
 * gerçekten basması gereken şeyin üstünü örter: hazır spor kitabında
 * sağlayıcının kupon çubuğunu, ödeme ekranında "Devam Et" düğmesini ve
 * ekrandaki hesap bilgilerini (canlıda ölçüldü — 92px'lik launcher tam
 * oraya düşüyor).
 *
 * **Üç kapı birlikte gerekir ve hiçbiri tek başına yetmez**, çünkü destek üç
 * ayrı yerden gelebilir:
 *
 * 1. **Sitenin kendi LiveChat widget'ı** — `suppressLiveChat()`. Sayaçlıdır;
 *    widget'ı yalnızca `LiveChatSupport` çizdiği için isteyen taraf onu
 *    doğrudan bulamaz.
 * 2. **Panelden girilen özel koddan gelen üçüncü taraf widget'ı** —
 *    `suppressFloatingWidgets()`. O script düğümlerini çalışma anında
 *    `<body>`ye ekler: React ağacımızda değildir, `window.LiveChatWidget`
 *    API'sini taşımaz ve koddan "kapat" denemez; tek tutamak DOM'dur.
 *    **Kurulumların çoğunda canlı destek bu yoldan gelir** — yalnızca
 *    birinci kapıyı kapatan bir düzeltme orada hiçbir şey değiştirmez.
 * 3. **Ölçüye güvenmeyen koşulsuz kapı** — `chat-free-page` sınıfının CSS
 *    kuralı (App.css). İkinci kapı `position: fixed` ve ekrandaki yer
 *    ölçüsüne dayanır ve kaçırabilir (dar ekranda widget kenardan kenara
 *    uzanır, bir kısmı da kapsayıcısını önce ölçüsüz ekler). Kural React
 *    kökünün **dışında** kalan her şeyi gizler: oyuncu portalında `<body>`nin
 *    doğrudan çocuğu olarak yalnızca uygulamanın kökü, açılış ekranı ve
 *    panelden girilen özel kodun düğümleri bulunur — `createPortal` kullanan
 *    tek yer yönetim panelidir ve bu sayfalarda çizilmez.
 *
 * Script'e **dokunulmaz**: sökülüp yeniden eklenen özel kod ikinci kez
 * çalışırdı (bkz. lib/customCode.js). Gizleme inline stille değil işaretle
 * yapılır; sayfadan çıkıldığında widget aynen geri döner.
 *
 * Destek, kabuğun kendi "Canlı Destek" düğmesinden açılmaya devam eder — o
 * düğmeler `openLiveChat()` üzerinden geçer (LiveChat'in `maximize` çağrısı
 * gizlenmiş widget'ta çalışmaz).
 */
export const CHAT_FREE_CLASS = 'chat-free-page';

const useChatFreePage = (active = true) => {
  useEffect(() => {
    if (!active) return undefined;
    document.body.classList.add(CHAT_FREE_CLASS);
    const releaseLiveChat = suppressLiveChat();
    const releaseWidgets = suppressFloatingWidgets();
    return () => {
      releaseWidgets();
      releaseLiveChat();
      document.body.classList.remove(CHAT_FREE_CLASS);
    };
  }, [active]);
};

export default useChatFreePage;
